import { render, staticRenderFns } from "./Gzly.vue?vue&type=template&id=882d6c28&scoped=true&lang=true&"
import script from "./Gzly.vue?vue&type=script&lang=js&"
export * from "./Gzly.vue?vue&type=script&lang=js&"
import style0 from "../../../vab/styles/gaikuang/gaikuang_big.css?vue&type=style&index=0&id=882d6c28&prod&scoped=true&lang=css&"
import style1 from "../../../vab/styles/gaikuang/gaikuang_mid.css?vue&type=style&index=1&id=882d6c28&prod&scoped=true&lang=css&"
import style2 from "../../../vab/styles/gaikuang/gaikuang_small.css?vue&type=style&index=2&id=882d6c28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d6c28",
  null
  
)

export default component.exports